module.exports = __webpack_public_path__ + "8a3db6670f5b38604a5386be2407f048.svg";